module.exports = __webpack_public_path__ + "static/img/10.8666770.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/zh/10.png
// module id = 1DQx
// module chunks = 0